import React from "react";
import { observer } from "mobx-react";
import { Button } from "antd";
import { PlusOutlined, EditFilled } from "@ant-design/icons";
import ewtStore from "../EWTStore";
import { theme } from "../theme";

const sortPlayersByName = (players) =>
  [...players].sort((a, b) => {
    const last = (a.last_name || "").localeCompare(b.last_name || "");
    if (last !== 0) return last;
    return (a.first_name || "").localeCompare(b.first_name || "");
  });

const newPlayerTemplate = () => ({
  tournaments: [],
  handicaps: {},
  active: true,
  admin: false,
  first_name: "",
  last_name: "",
  nickname: "",
});

const Players = observer(
  class Players extends React.Component {
    state = {
      players: null,
      loading: true,
    };

    componentDidMount() {
      ewtStore.playersListRefresh = this.loadPlayers;
      this.loadPlayers();
    }

    componentWillUnmount() {
      ewtStore.playersListRefresh = null;
    }

    loadPlayers = async () => {
      this.setState({ loading: true });
      const players = await ewtStore.getAllPlayers();
      this.setState({ players, loading: false });
    };

    openPlayer = (player) => {
      ewtStore.openPlayerCard(player);
    };

    openAddPlayer = () => {
      ewtStore.openPlayerEdit(newPlayerTemplate());
    };

    openEditPlayer = (player, e) => {
      e.stopPropagation();
      ewtStore.openPlayerEdit(player);
    };

    render() {
      const isAdmin = ewtStore.player && ewtStore.player.admin;
      const { players, loading } = this.state;

      return (
        <div className="flexColumn" style={{ height: "100%", padding: 12 }}>
          {isAdmin && (
            <Button
              type="primary"
              style={{
                fontSize: 16,
                height: 40,
                marginBottom: 10,
                alignSelf: "flex-start",
              }}
              onClick={this.openAddPlayer}
            >
              <PlusOutlined /> Add Player
            </Button>
          )}
          {loading && <div style={{ fontSize: 18, color: theme.slate }}>Loading...</div>}
          {!loading && players && players.length === 0 && (
            <div style={{ fontSize: 18, color: theme.slate }}>No players found.</div>
          )}
          {!loading && players && (
            <div className="flexScroll" style={{ flex: 1 }}>
              {sortPlayersByName(players).map((player, index) => (
                <div
                  key={player.id}
                  className="flexRow ewtModalListItem"
                  style={{
                    backgroundColor: index % 2 === 0 ? theme.surface : theme.surfaceAlt,
                  }}
                  onClick={() => this.openPlayer(player)}
                >
                  <div style={{ width: 120, fontWeight: 600, color: theme.navy }}>
                    {player.last_name}
                  </div>
                  <div style={{ width: 120, color: theme.navy }}>{player.first_name}</div>
                  <div style={{ flex: 1, color: theme.slate }}>{player.nickname}</div>
                  {isAdmin && (
                    <EditFilled
                      onClick={(e) => this.openEditPlayer(player, e)}
                      style={{ fontSize: 20, padding: 4, cursor: "pointer", color: theme.brandBlue }}
                    />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }
  }
);

export default Players;
